import React from "react";
import fashion from '../Images/Logo1.png'
import fashio from '../Images/Logo2.png'
import fashi from '../Images/Logo3.png'
import fash from '../Images/Logo4.png'
import fas from '../Images/Logo5.png'
import fa from '../Images/Logo6.png'


const Secone = () => {
    return (
        <>
          <div className="container pb-5 mt-5">
            <div className="logo-marquee">
              <div className="logo-track">
                <img src={fashion} alt="" />
                <img src={fashio} alt="" />
                <img src={fashi} alt="" />
                <img src={fash} alt="" />
                <img src={fas} alt="" />
                <img src={fa} alt="" />


                <img src={fashion} alt="" />
                <img src={fashio} alt="" />
                <img src={fashi} alt="" />
                <img src={fash} alt="" />
                <img src={fas} alt="" />
                <img src={fa} alt="" />
              </div>
            </div>
          </div>

        </>
    )
}

export default Secone;